import React from 'react'
import ContactFormBlock, { ContactFormProps } from './contact-form'
import {
    BannerImageBlock,
    BannerImageBlockProps,
    DoubleBannerImageBlock,
    DoubleBannerImageBlockProps,
} from './banner-image'
import ImageGridBlock, { ImageGridBlockProps } from './image-grid'
import LinkBlock, { LinkBlockProps } from './link'
import TableBlock, { TableBlockProps } from './table'
import TeamBlock, { TeamBlockProps } from './team'
import TextBlock, { TextBlockProps } from './text'
import TextGridBlock, { TextGridBlockProps } from './text-grid'
import VideoBlock, { VideoBlockProps } from './video'
import { StoryBlock, StoryBlockProps } from './story'
import Border from '../border'

interface BlockProps {
    blockType: string
}

interface IContactFormBlock extends ContactFormProps, BlockProps { blockType: 'contactForm' }
interface IBannerImageBlock extends BannerImageBlockProps, BlockProps { blockType: 'bannerImage' }
interface IDoubleBannerImageBlock extends DoubleBannerImageBlockProps, BlockProps { blockType: 'doubleBannerImage' }
interface IImageGridBlock extends ImageGridBlockProps, BlockProps { blockType: 'imageGrid' }
interface ILinkBlock extends LinkBlockProps, BlockProps { blockType: 'link' }
interface IStoryBlock extends StoryBlockProps, BlockProps { blockType: 'story' }
interface ITableBlock extends TableBlockProps, BlockProps { blockType: 'table' }
interface ITeamBlock extends TeamBlockProps, BlockProps { blockType: 'team' }
interface ITextBlock extends TextBlockProps, BlockProps { blockType: 'text' }
interface ITextGridBlock extends TextGridBlockProps, BlockProps { blockType: 'textGrid' }
interface IVideoBlock extends VideoBlockProps, BlockProps { blockType: 'video' }
interface IDividerBlock { blockType: 'divider' }

export type ContentBlock =
    IContactFormBlock | IBannerImageBlock | IDoubleBannerImageBlock | IImageGridBlock | IDividerBlock |
    ILinkBlock | ITableBlock | ITeamBlock | ITextBlock | ITextGridBlock | IVideoBlock | IStoryBlock

export interface ContentBlockZoneProps {
    blocks: Array<ContentBlock>
}

const ContentBlockZone = ({ blocks }: ContentBlockZoneProps) => {
    return (
        <>
            {blocks.map((block, index) => {
                const { blockType, ...props } = block
                const key = `content-${index}`

                switch (blockType) {
                case 'contactForm':
                    return <ContactFormBlock {...props as ContactFormProps} key={key} />

                case 'bannerImage':
                    return <BannerImageBlock {...props as BannerImageBlockProps} key={key} />

                case 'imageGrid':
                    return <ImageGridBlock {...props as ImageGridBlockProps} key={key}
                    />

                case 'doubleBannerImage':
                    return <DoubleBannerImageBlock {...props as DoubleBannerImageBlockProps} key={key} />

                case 'link':
                    return <LinkBlock {...props as LinkBlockProps} key={key} />

                case 'divider':
                    return <Border key={key} />

                case 'story':
                    return <StoryBlock {...props as StoryBlockProps} key={key} />

                case 'table':
                    return <TableBlock {...props as TableBlockProps} key={key} />

                case 'team':
                    return <TeamBlock {...props as TeamBlockProps} key={key} />

                case 'text':
                    return <TextBlock {...props as TextBlockProps} key={key} />

                case 'textGrid':
                    return <TextGridBlock {...props as TextGridBlockProps} key={key} />

                case 'video':
                    return <VideoBlock {...props as VideoBlockProps} key={key} />

                default:
                    throw Error(`Unknown content block type '${blockType}'`)
                }
            })}
        </>
    )
}

export default ContentBlockZone
